import React from "react";
import { DownloadSimple } from "@phosphor-icons/react";

const DEFAULT_PLAY_STORE_URL = "https://play.google.com/apps/internaltest/4700748388413356528";
const DEFAULT_APK_URL = "https://nexoracd.cloud/downloads/nexora-cab.apk";

function PlayStoreIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={className}>
      <path fill="#00D084" d="M4.8 3.7c-.5.3-.8.9-.8 1.7v21.2c0 .8.3 1.4.8 1.7L17.7 16 4.8 3.7Z" />
      <path fill="#25D9F8" d="m20.2 13.6-3.1-3L4.8 3.7 20.2 13.6Z" />
      <path fill="#FFCE2E" d="m20.2 18.4-3.1 3L4.8 28.3 20.2 18.4Z" />
      <path fill="#FF5A44" d="m27.4 14.2-7.2-4.1-3.1 5.9 3.1 5.9 7.2-4.1c1.3-.8 1.3-2.8 0-3.6Z" />
    </svg>
  );
}

function getPlatform() {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}

export default function AppDownloadButtons({ className = "", compact = false, onAction }) {
  const playStoreUrl = process.env.REACT_APP_PLAY_STORE_URL || DEFAULT_PLAY_STORE_URL;
  const apkUrl = process.env.REACT_APP_ANDROID_APK_URL || DEFAULT_APK_URL;
  const platform = getPlatform();
  const isIOS = platform === "ios";
  const isAndroid = platform === "android";

  return (
    <div className={`grid gap-2 ${compact || isIOS ? "" : "sm:grid-cols-2"} ${className}`}>
      {!isIOS && (
        <a
          href={playStoreUrl}
          target="_blank"
          rel="noreferrer"
          onClick={onAction}
          className="group flex min-h-12 items-center justify-center gap-3 rounded-2xl border border-white/15 bg-black px-4 py-3 text-left text-white transition hover:border-primary/50 hover:bg-black/90"
        >
          <PlayStoreIcon className="h-7 w-7 shrink-0" />
          <span className="leading-none">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-white/60">Test ferme</span>
            <span className="block font-heading text-sm font-black">Play Store</span>
          </span>
        </a>
      )}

      {isIOS ? (
        <div className="rounded-2xl border border-primary/25 bg-primary/10 p-3 text-left text-xs leading-5 text-muted-foreground">
          <div className="font-heading text-sm font-black text-foreground">Installation iPhone</div>
          <ol className="mt-2 list-decimal space-y-1 pl-4">
            <li>Ouvrez Nexora dans Safari.</li>
            <li>Touchez le bouton partager.</li>
            <li>Choisissez Ajouter a l'ecran d'accueil.</li>
            <li>Validez avec Ajouter.</li>
          </ol>
        </div>
      ) : (
        <a
          href={apkUrl}
          target={isAndroid ? "_self" : "_blank"}
          rel="noreferrer"
          onClick={onAction}
          className="flex min-h-12 items-center justify-center gap-3 rounded-2xl border border-primary/30 bg-primary/10 px-4 py-3 text-primary transition hover:bg-primary/15"
        >
          <DownloadSimple size={22} weight="bold" />
          <span className="leading-none">
            <span className="block text-[10px] font-bold uppercase tracking-widest opacity-70">Installation directe</span>
            <span className="block font-heading text-sm font-black">APK Android</span>
          </span>
        </a>
      )}
    </div>
  );
}
